import React, { useCallback, useMemo, useState } from "react";
import { Slate, Editable, withReact } from "slate-react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import MarkButton from "./plugins/MarkButton";
import BlockButton, { InsertImageButton } from "./plugins/BlockButton";
import { Toolbar } from "./plugins/Toolbar";
import Element from "./plugins/Element";
import withImages, {withCorrectVoidBehavior} from "./plugins/hooks/withImages";
import {
  Bold_Logo,
  Italic_Logo,
  Underline_Logo,
  Code_Logo,
  Heading1_Logo,
  Heading2_Logo,
  Unordered_List_Logo,
  Ordered_List_Logo,
  Left_Align_Logo,
  Center_Align_Logo,
  Right_Align_Logo,
  Justify_Align_Logo
} from "./plugins/Icons";


export const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
};

const RichTextField = ({ formik, id, placeholder, value, ...props }) => {
  const editor = useMemo(() => withCorrectVoidBehavior(withImages(withHistory(withReact(createEditor())))), []);
  
  const renderLeaf = useCallback((props) => <Leaf {...props} />, []);
  const renderElement = useCallback((props) => <Element {...props} />, []);
  const initialValue = [
    {
      type: "paragraph",
      children: [{ text: placeholder ? `${placeholder}` : '' }],
    },
  ];

  const content = (values) => {
    const isAtChange = editor.operations.some((op)=>'set_selection' !== op.type);
    if(isAtChange) {
      formik.setFieldValue(id,JSON.stringify(values));
    }
  }

  let minHeight = ( props.minHeight )  ? props.minHeight : 80;
  let editableClass = ( props.editableClass )  ? props.editableClass : '';

  return (
    <div>
      <Slate editor={editor} 
        value={value ? value : initialValue} 
        onChange={value => content(value)} 
        >
        <Toolbar>
          <MarkButton format="bold" icon={<Bold_Logo />} />
          <MarkButton format="italic" icon={<Italic_Logo />} />
          <MarkButton format="underline" icon={<Underline_Logo />} />
          <MarkButton format="code" icon={<Code_Logo />} />
          <BlockButton format="heading-one" icon={<Heading1_Logo />} />
          <BlockButton format="heading-two" icon={<Heading2_Logo />} />
          <BlockButton format="bulleted-list" icon={<Unordered_List_Logo />} />
          <BlockButton format="numbered-list" icon={<Ordered_List_Logo />} />
          <BlockButton format="left" icon={<Left_Align_Logo />} />
          <BlockButton format="center" icon={<Center_Align_Logo />} />
          <BlockButton format="right" icon={<Right_Align_Logo />} />
          <BlockButton format="justify" icon={<Justify_Align_Logo />} />
          <InsertImageButton />
        </Toolbar>
        <Editable
          className={`form-control h-auto ${editableClass}`}
          style={{minHeight: minHeight}}
          renderLeaf={renderLeaf}
          renderElement={renderElement}
        />
      </Slate>
    </div>
  );
};

export default RichTextField;
